import { ideaResult } from '@/services/result-service'
import { computed, onMounted, reactive } from 'vue'
import type { ImageRecord } from '@/types';
import { useRoute } from 'vue-router';
import { ImagePanelService } from '@eureka/shared/solution-card';

export function useIdeaResult() {
    const route = useRoute()

    const imagePanelService = reactive(new ImagePanelService());

    const haveSearched = computed(() => {
        return ideaResult.value.searchCounts > 0
    })

    const solutions = computed(() => {
        return ideaResult.value.results
    })

    const solutionIds = computed(() => {
        return solutions.value.map(item => item.patent_id)
    })

    const solutionTotalCounts = computed(() => {
        return solutions.value.length
    })

    const solutionListLoading = computed(() => {
        return ideaResult.value.getResultLoading
    })

    const solutionListEmpty = computed(() => {
        return !solutionListLoading.value && !solutionTotalCounts.value
    })

    function liftByPatentNumber(id: string) {
        ideaResult.value.liftByPatentNumber(id)
    }

    function openCardImagePanel(params: {
        images?: ImageRecord[], order?: number
    }) {
        if (!params.images) return
        imagePanelService.imageList = params.images
        imagePanelService.open(params.order)
    }

    const scrollToPatentCard = () => {
        const scrollFromId = route.query.fromId
        if (!scrollFromId) return
        setTimeout(() => {
            const patentCard = document.querySelector(`.idea-solution-card[data-patent-id="${scrollFromId}"]`);
            patentCard?.scrollIntoView({ behavior: 'smooth' });
        }, 500);
    };

    onMounted(() => {
        scrollToPatentCard();
    })

    return {
        solutions,
        solutionIds,
        solutionListEmpty,
        solutionListLoading,
        liftByPatentNumber,
        imagePanelService,
        openCardImagePanel,
        solutionTotalCounts,
        haveSearched,
    }
}
